<template>

  <nav class="navbar navbar-expand-md fixed-top navbar-dark">
    <div class="container">
      <router-link class="navbar-brand fw-bold terminal-brand" to="/">
        <span class="terminal-prompt">~/</span>jonathan<span class="blink">_</span>
      </router-link>

      <button
        class="navbar-toggler terminal-toggler"
        type="button"
        @click="navOpen = !navOpen"
        aria-label="Toggle navigation"
      >
        <span class="toggler-bar"></span>
        <span class="toggler-bar"></span>
        <span class="toggler-bar"></span>
      </button>

      <div class="collapse navbar-collapse" :class="{ show: navOpen }">
        <div class="navbar-nav ms-auto">
          <router-link class="nav-link terminal-link" to="/" data-bloop-id="nav_home" data-bloop-kind="nav">
            <span class="terminal-prefix">&gt;</span> home
          </router-link>
          <router-link class="nav-link terminal-link" to="/projects" data-bloop-id="nav_projects" data-bloop-kind="nav">
            <span class="terminal-prefix">&gt;</span> projects
          </router-link>
          <router-link class="nav-link terminal-link" to="/Contact" data-bloop-id="nav_contact" data-bloop-kind="nav">
            <span class="terminal-prefix">&gt;</span> contact
          </router-link>
        </div>
      </div>
    </div>
  </nav>

  <div class="scanlines"></div>

  <div class="content-container" style="padding-top: 80px;" ref="contentContainer">
    <router-view></router-view>
  </div>


    <!-- Footer -->
    <footer class="footer">
    <div class="container">
      <div class="terminal-footer">
        <span class="footer-prompt">guest@jonathanback:~$</span> connect --social
      </div>
      <div class="social-links">
        <a href="https://www.linkedin.com/in/jonathan-back-699a26214/" target="_blank" class="social-link" data-bloop-id="social_linkedin" data-bloop-kind="social">[LinkedIn]</a>
        <a href="https://github.com/JonBacc" target="_blank" class="social-link" data-bloop-id="social_github" data-bloop-kind="social">[GitHub]</a>
        <a href="https://www.instagram.com/joonathanback/" target="_blank" class="social-link" data-bloop-id="social_instagram" data-bloop-kind="social">[Instagram]</a>
      </div>
      <div class="footer-status">
        <span class="status-dot"></span> System operational | Last updated: 2026
      </div>
    </div>
  </footer>

  <BloopLayer />

</template>

<script>
import BloopLayer from './components/bloop/BloopLayer.vue';

export default {
  components: { BloopLayer },
  data() {
    return {
      navOpen: false,
    };
  },
  watch: {
    // Close mobile menu when route changes
    $route() {
      this.navOpen = false;
    }
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap');
@import './resources/bootstrap-icons-1.9.1/bootstrap-icons.css';
@import'./resources/css/bootstrap.min.css';


:root {
  /* Terminal color palette - modern retro */
  --terminal-bg: #0a0e14;
  --terminal-bg-light: #111820;
  --terminal-green: #39ff14;
  --terminal-green-dim: #1a7a0a;
  --terminal-cyan: #00d9ff;
  --terminal-amber: #ffb800;
  --terminal-text: #e6edf3;
  --terminal-text-dim: #8b949e;
  --terminal-border: #30363d;
  --terminal-glow: rgba(57, 255, 20, 0.3);
  --terminal-card-bg: #161b22;

  /* Legacy aliases used by older views */
  --cc_main: var(--terminal-bg);
  --cc_Form: var(--terminal-card-bg);
  --cc_third: var(--terminal-text);
  --cc_second: var(--terminal-green-dim);
  --cc_b: var(--terminal-cyan);

  /* Gradient backgrounds */
  --gradient-dark: linear-gradient(135deg, #0a0e14 0%, #161b22 100%);
  --gradient-accent: linear-gradient(135deg, var(--terminal-green) 0%, var(--terminal-cyan) 100%);

  /* Bootstrap overrides */
  --bs-link-hover-color: var(--terminal-cyan) !important;
  --bs-link-color: var(--terminal-text) !important;
}

/* Blinking cursor animation */
@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}

@keyframes glow {
  0%, 100% { text-shadow: 0 0 5px var(--terminal-green), 0 0 10px var(--terminal-green); }
  50% { text-shadow: 0 0 10px var(--terminal-green), 0 0 20px var(--terminal-green), 0 0 30px var(--terminal-green); }
}

@keyframes scanline {
  0% { transform: translateY(-100%); }
  100% { transform: translateY(100vh); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Scanlines overlay */
.scanlines {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
  background: repeating-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.03),
    rgba(0, 0, 0, 0.03) 1px,
    transparent 1px,
    transparent 2px
  );
}

.scanlines::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(
    180deg,
    rgba(57, 255, 20, 0.1),
    transparent
  );
  animation: scanline 8s linear infinite;
}

.navbar {
  background: var(--terminal-bg);
  border-bottom: 1px solid var(--terminal-border);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5), 0 0 40px rgba(57, 255, 20, 0.05);
  backdrop-filter: blur(10px);
}

.terminal-brand {
  font-family: 'JetBrains Mono', monospace;
  font-size: 1.3rem;
  letter-spacing: -0.5px;
}

.terminal-prompt {
  color: var(--terminal-green);
}

.blink {
  animation: blink 1s step-end infinite;
  color: var(--terminal-green);
}

.terminal-toggler {
  border: 1px solid var(--terminal-border);
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.toggler-bar {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--terminal-green);
  transition: 0.3s;
}

.terminal-link {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  position: relative;
}

.terminal-prefix {
  color: var(--terminal-green);
  margin-right: 4px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.terminal-link:hover .terminal-prefix,
.terminal-link.router-link-exact-active .terminal-prefix,
.terminal-link.bloop-hover .terminal-prefix {
  opacity: 1;
}

.terminal-link:hover,
.terminal-link.bloop-hover {
  color: var(--terminal-cyan) !important;
  text-shadow: 0 0 10px var(--terminal-cyan);
}

.bi {
  font-size: 1.5rem;
}

#app {
  font-family: 'Space Grotesk', sans-serif;
  color: var(--terminal-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--terminal-bg);
  overflow-x: clip;
}

body {
  color: var(--terminal-text);
  background: var(--terminal-bg);
  overflow-x: clip;
}

body::-webkit-scrollbar {
  width: 8px;
}

body::-webkit-scrollbar-track {
  background: var(--terminal-bg);
}

body::-webkit-scrollbar-thumb {
  background: var(--terminal-border);
  border-radius: 4px;
}

body::-webkit-scrollbar-thumb:hover {
  background: var(--terminal-green-dim);
}

nav {
  padding: 10px 0;
}

.navbar-nav .nav-link {
  font-weight: 500;
  color: var(--terminal-text) !important;
}

.navbar-nav .nav-link.router-link-exact-active {
  color: var(--terminal-green) !important;
  text-shadow: 0 0 10px var(--terminal-glow);
}

a, a:visited, a:hover, a:focus, a:active {
  color: var(--terminal-text);
  text-decoration: none !important;
}

a:hover {
  color: var(--terminal-cyan);
}

.terminal-link:focus-visible,
.social-link:focus-visible,
.btn:focus-visible,
.navbar-brand:focus-visible {
  outline: 2px solid var(--terminal-cyan);
  outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
  .blink,
  .cursor,
  .status-dot,
  .scanlines::after {
    animation: none !important;
  }
}

table {
  margin-left: auto;
  margin-right: auto;
  width: 80%;
}

/* Terminal-style buttons */
.btn {
  font-family: 'JetBrains Mono', monospace;
  background: transparent !important;
  color: var(--terminal-green) !important;
  border: 1px solid var(--terminal-green) !important;
  transition: all 0.3s ease;
  font-weight: 500 !important;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: var(--terminal-green);
  transition: left 0.3s ease;
  z-index: -1;
}

.btn:hover {
  color: var(--terminal-bg) !important;
  border-color: var(--terminal-green) !important;
  box-shadow: 0 0 20px var(--terminal-glow);
}

.btn:hover::before {
  left: 0;
}

/* Footer styles */
.footer {
  background: var(--terminal-bg-light);
  border-top: 1px solid var(--terminal-border);
  color: var(--terminal-text);
  text-align: center;
  padding: 30px 20px;
  width: 100%;
}

.terminal-footer {
  font-family: 'JetBrains Mono', monospace;
  color: var(--terminal-text-dim);
  margin-bottom: 15px;
  font-size: 0.9rem;
}

.footer-prompt {
  color: var(--terminal-green);
}

.social-links {
  margin-bottom: 15px;
}

.social-link {
  font-family: 'JetBrains Mono', monospace;
  margin: 0 15px;
  color: var(--terminal-text) !important;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.social-link:hover,
.social-link.bloop-hover {
  color: var(--terminal-cyan) !important;
  text-shadow: 0 0 10px var(--terminal-cyan);
}

.footer-status {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.75rem;
  color: var(--terminal-text-dim);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.status-dot {
  width: 8px;
  height: 8px;
  background: var(--terminal-green);
  border-radius: 50%;
  animation: pulse 2s ease-in-out infinite;
  box-shadow: 0 0 10px var(--terminal-green);
}

.content-container {
  flex: 1;
  padding-top: 75px;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px var(--terminal-card-bg) inset !important;
  -webkit-text-fill-color: var(--terminal-text) !important;
  transition: background-color 5000s ease-in-out 0s !important;
}

/* Terminal card component */
.terminal-card {
  background: var(--terminal-card-bg);
  border: 1px solid var(--terminal-border);
  border-radius: 8px;
  overflow: hidden;
}

.terminal-card-header {
  background: var(--terminal-bg);
  padding: 10px 15px;
  border-bottom: 1px solid var(--terminal-border);
  display: flex;
  align-items: center;
  gap: 8px;
}

.terminal-dots {
  display: flex;
  gap: 6px;
}

.terminal-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.terminal-dot.red { background: #ff5f56; }
.terminal-dot.yellow { background: #ffbd2e; }
.terminal-dot.green { background: #27c93f; }

.terminal-card-title {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  color: var(--terminal-text-dim);
  margin-left: 10px;
}

.terminal-card-body {
  padding: 20px;
}

/* Progress bar terminal style */
.progress {
  background: var(--terminal-bg);
  border: 1px solid var(--terminal-border);
  border-radius: 4px;
  height: 20px;
  overflow: hidden;
}

.progress-bar {
  background: linear-gradient(90deg, var(--terminal-green-dim), var(--terminal-green));
  color: var(--terminal-bg);
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.75rem;
  font-weight: 600;
}

/* Section headers */
.section-header {
  font-family: 'JetBrains Mono', monospace;
  color: var(--terminal-green);
  margin-bottom: 30px;
}

.section-header::before {
  content: '## ';
  opacity: 0.5;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .terminal-brand {
    font-size: 1.1rem;
  }

  .terminal-link {
    font-size: 0.85rem;
  }
}

</style>
